<div class="presentation flex flex-column" role="region" aria-label="Note presentation">
  <header class="presentation-header flex align-items-center justify-content-between gap-3">
    <nav class="breadcrumb flex align-items-center gap-2" [attr.aria-label]="'Note path: ' + breadcrumbLabel" [attr.title]="breadcrumbLabel">
      <ng-container *ngFor="let item of breadcrumbItems; let first = first">
        <mat-icon *ngIf="!first" class="breadcrumb-divider" aria-hidden="true">chevron_right</mat-icon>
        <span class="breadcrumb-segment" [class.breadcrumb-current]="item.kind === 'current'"
          [class.breadcrumb-ellipsis]="item.kind === 'ellipsis'"
          [attr.title]="item.kind === 'ellipsis' ? breadcrumbLabel : item.label"
          [attr.aria-hidden]="item.kind === 'ellipsis' ? true : null">{{ item.label }}</span>
      </ng-container>
    </nav>

    <button mat-icon-button class="control-button close-button" type="button"
      aria-label="Close presentation" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <main class="presentation-body flex align-items-center justify-content-center">
    <div class="slide-canvas" [class.image-and-text]="hasImage && hasText" [class.image-only]="hasImage && !hasText">
      <section *ngIf="hasImage" class="image-pane flex align-items-center justify-content-center"
        aria-label="Note image">
        <img *ngFor="let image of currentImages; trackBy: trackImage" class="slide-image"
          [class.is-loading]="currentImageState !== 'loaded'"
          [src]="image.url" alt="Image attached to this note"
          (load)="onImageLoaded(image.slideId)" (error)="onImageError(image.slideId)">

        <div *ngIf="currentImageState === 'loading'" class="image-message" role="status">
          Loading image...
        </div>

        <div *ngIf="currentImageState === 'error'" class="image-message flex flex-column align-items-center gap-2" role="alert">
          <mat-icon aria-hidden="true">broken_image</mat-icon>
          <span>Unable to load image</span>
          <button mat-button type="button" (click)="retryImage()">Retry</button>
        </div>
      </section>

      <section *ngIf="hasText" class="text-pane flex align-items-center justify-content-center"
        [class.text-only]="!hasImage" aria-label="Note text">
        <div #textViewport class="text-viewport" role="region" tabindex="0"
          aria-label="Note text. Use Up and Down arrow keys to scroll.">
          <p #slideText class="slide-text" [style.fontSize.px]="textSizePx">{{ currentSlide?.text }}</p>
        </div>
      </section>

      <div *ngIf="!hasImage && !hasText" class="empty-slide flex align-items-center justify-content-center">
        This note is empty.
      </div>
    </div>
  </main>

  <footer class="presentation-footer flex align-items-center justify-content-center gap-3">
    <button mat-icon-button class="control-button" type="button" aria-label="Previous note"
      [disabled]="currentIndex === 0 || !slides.length" (click)="previous()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <span class="slide-counter">{{ slides.length ? currentIndex + 1 : 0 }} / {{ slides.length }}</span>
    <span class="slide-announcement" aria-live="polite" aria-atomic="true">{{ slideAnnouncement }}</span>

    <button mat-icon-button class="control-button" type="button" aria-label="Next note"
      [disabled]="currentIndex >= slides.length - 1" (click)="next()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </footer>
</div>
